import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from "Core/defaultValues";
import { ExceptionManager, LogManagerConsole } from 'Core/logManager';

import { resetALL } from 'Redux/actions';

//STATE INITIAL
const INIT_STATE = {
  open: false,
  loading: false,
  error: null,
  data: null,
  total: 0
};

const route = 'modules/maintenance/views/main/components/emissionCheckTab/modals/events/redux/slice'

export const emissionCheckEventsOpen = createAsyncThunk('emissionCheck/events/open', async ({ item, conditions, sort, limit = 10, offset = 0 }, { rejectWithValue, dispatch, getState }) => {
  try {
    LogManagerConsole("EmissionCheck", "emissionCheckEventsOpen", conditions);
    //if the action is created 
    if (!item?.id) return null

    //if action is edited
    const response = await clientQuery(
      `query searchCarbScheduleLogs($conditions: [CarbScheduleLogSearchInput], $sort: [CarbScheduleLogSortInput], $limit: Int, $offset: Int) {
        data: searchCarbScheduleLogs(conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
        items {
          id
            carbScheduleId
            scanStatus
            scanDate
            errorMessage
            reportFilename
            createdOn
          }
        total
      }
    }`,
      {
        conditions,
        sort,
        limit,
        offset
      },
      endpoints.GRAPHQL_GENERAL_V2
    );

    LogManagerConsole("EmissionCheck", "eventsOpen", response);
    return { item, events: response?.data?.items, total: response?.data?.total };
  } catch (exc) {
    ExceptionManager(exc, route, 'EmissionCheckEventsOpen');
    return rejectWithValue(exc)
  }
});

const emissionCheckEventsRedux = createSlice({
  name: 'EmissionCheck/events',
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE
    },
    closeModal(state, action) {
      state.open = false
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    builder.addCase(emissionCheckEventsOpen.pending, (state, action) => {
      state.loading = true
    });
    builder.addCase(emissionCheckEventsOpen.fulfilled, (state, action) => {
      state.loading = false;
      state.open = true
      state.data = action.payload
    });
    builder.addCase(emissionCheckEventsOpen.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload
    });
  },
})

// Extract and export the action creators object and the reducer
export const { actions, reducer } = emissionCheckEventsRedux;

// Extract and export each action creator by name
export const { reset, closeModal } = actions;

//Simple async action

// Export the reducer, either as a default or named export
export default reducer;